<template>
   <div class="text-input">
      <label><b>{{label}}</b></label>
      <div class="input-group">
        <input 
          :type="type"
          class="form-control" 
          :disabled="disabled"
          :placeholder="placeholder"  
          :style="customStyles"
          :value="value"
          :v-focus="focus"
          @input="change"
          :aria-label="label">
      </div>
      <div v-if="validator && validator.$error && validator.$dirty">
         <div class="validation-error" v-for="key in Object.keys(validator.$params)" v-if="!validator[key]">{{ validatorMsgMap[key] }}</div>
      </div>
   </div>
</template>

<script>
   export default {
     name: "BasicTextInput",
     props: {
        label: {
           type: String,
        },
        placeholder: {
           type: String,
        },
        focus: {
           type: Boolean,
           default: false,
        },
        disabled: {
           type: Boolean,
           default: false,
        },
        value: {
           type: String,
        },
        type: {
           type: String,
           default: 'text'
        },
        customStyles: {
            type: Object,
        },
        validatorMsgMap: {
            type: Object,
            default: null,
        },
        validator: {
            type: Object,
            default: null,
        }
     },
     methods: {
        change($event){
            this.$emit('input',$event.target.value)
            this.$emit('change')
           
        }
     },
     directives: {
         focus: {
            // directive definition
            inserted: function (el) {
            el.focus()
            }
         }
      },
   }
</script>

<style lang="scss" scoped>
</style>
